import React from "react";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import StatCard from "../../../components/StatCard/StatCard.jsx";
import styles from "./SyncStatsOverview.module.css";

const SyncStatsOverview = ({ overview }) => {
    if (!overview) return null;

    return (
        <Container fluid>
            <div className={styles.statsGrid}>
                <StatCard>
                    <StatCard.Header icon="fas fa-list">Estrategias</StatCard.Header>
                    <StatCard.Value>
                        {overview.overall.strategies_processed} Procesadas
                    </StatCard.Value>
                    <StatCard.Footer>
                        <StatCard.SuccessText>{overview.overall.strategies_succeeded} OK</StatCard.SuccessText>
                        <StatCard.DangerText>{overview.overall.strategies_with_errors} con Errores</StatCard.DangerText>
                    </StatCard.Footer>
                </StatCard>

                <StatCard>
                    <StatCard.Header icon="fas fa-file-invoice">Journals</StatCard.Header>
                    <StatCard.Value>
                        {overview.overall.extractions.journals_sent} Enviados
                    </StatCard.Value>
                    <StatCard.Footer>
                        <StatCard.SuccessText>{overview.overall.extractions.journals_synchronized} Sincronizados</StatCard.SuccessText>
                        <StatCard.DangerText>{overview.overall.incidents.journals_with_errors} con Errores</StatCard.DangerText>
                    </StatCard.Footer>
                </StatCard>

                <StatCard>
                    <StatCard.Header icon="fas fa-check-circle">Compliances</StatCard.Header>
                    <StatCard.Value>
                        {overview.overall.extractions.compliances} Enviados
                    </StatCard.Value>
                    <StatCard.Footer>
                        <StatCard.SuccessText>{overview.overall.extractions.compliances_synchronized} Sincronizados</StatCard.SuccessText>
                        <StatCard.WarningText>{overview.overall.incidents.compliances_pending} Pendientes</StatCard.WarningText>
                    </StatCard.Footer>
                </StatCard>

                <StatCard>
                    <StatCard.Header icon="fas fa-box">Batches</StatCard.Header>
                    <StatCard.Value>
                        {overview.metadata.batches} Totales
                    </StatCard.Value>
                    <StatCard.Footer>
                        <StatCard.SuccessText>{overview.metadata.synchronized_batches} Sincronizados</StatCard.SuccessText>
                        <StatCard.WarningText>{overview.metadata.pending_batches} Pendientes</StatCard.WarningText>
                    </StatCard.Footer>
                </StatCard>
            </div>
        </Container>
    );
};

SyncStatsOverview.propTypes = {
    overview: PropTypes.shape({
        overall: PropTypes.shape({
            strategies_processed: PropTypes.number.isRequired,
            strategies_succeeded: PropTypes.number.isRequired,
            strategies_with_errors: PropTypes.number.isRequired,
            extractions: PropTypes.shape({
                journals_sent: PropTypes.number.isRequired,
                journals_synchronized: PropTypes.number.isRequired,
                compliances: PropTypes.number.isRequired,
                compliances_synchronized: PropTypes.number.isRequired,
            }).isRequired,
            incidents: PropTypes.shape({
                journals_with_errors: PropTypes.number.isRequired,
                compliances_pending: PropTypes.number.isRequired,
            }).isRequired,
        }).isRequired,
        metadata: PropTypes.shape({
            batches: PropTypes.number.isRequired,
            synchronized_batches: PropTypes.number.isRequired,
            pending_batches: PropTypes.number.isRequired,
        }).isRequired,
    }),
};

SyncStatsOverview.defaultProps = {
    overview: null,
};

export default SyncStatsOverview;
